/* const Sizes = {
  Text: {
    h1: "32px",
    h2: "20px",
    h3: "16px",
    h4: "14px",
    p: "12px",
  },
}; */

const Sizes = {
  Text: {
    h1: "64px",
    h2: "40px",
    h3: "32px",
    h4: "28px",
    p: "24px",
  },
};

export { Sizes };
